import HttpService from 'domovio-core/src/system/rest/rest.service';

// UNITS
export async function createUnit(data) {
    return HttpService.post('/v1/units', data)
}

export async function loadUnits(projectId) {
    return HttpService.get('/v1/units', {projectId});
}

export async function loadUnit(unitId) {
    return HttpService.get('/v1/units/' + unitId);
}

export async function updateUnit(data) {
    const {id} = data;
    delete data.id;
    return HttpService.put('/v1/units/' + id, data);
}

export async function copyUnit(data) {
    const {id} = data;
    delete data.id;
    return HttpService.post('/v1/units/' + id + '/copy', data);
}

// UNITS FILES

export async function updateUnitFiles(data) {
    const {id} = data;
    delete data.id;
    return HttpService.post('/v1/units/' + id + '/files', data);
}

// UNITS IMAGES

export async function updateUnitImages(data) {
    const {id} = data;
    delete data.id;
    return HttpService.post('/v1/units/' + id + '/images', data);
}

// UNITS ACCESSORIES
export async function updateUnitAccessory(data) {
    const {id} = data;
    delete data.id;
    return HttpService.post('/v1/units/' + id + '/accessories', data);
}

// UNITS ORIENTATIONS
export async function updateUnitOrientation(data) {
    const {id} = data;
    delete data.id;
    return HttpService.post('/v1/units/' + id + '/orientations', data);
}

export async function createFloorPlan(data) {
    const tempId = Math.random() * 1;
    return new Promise((resolve) => resolve({...data, rooms: [], id: tempId.toString()}));
}

export async function updateFloorPlan(data) {
    return new Promise((resolve) => resolve(data));
}

export async function removeFloorPlan(id) {
    return new Promise((resolve) => resolve(id));
}

export async function createFloorPlanRoom(data) {
    const tempId = Math.random() * 1;
    delete data.floorPlanId;
    return new Promise((resolve) => resolve({...data, id: tempId.toString()}));
}

export async function updateFloorPlanRoom(data) {
    delete data.floorPlanId;
    return new Promise((resolve) => resolve(data));
}

export async function removeFloorPlanRoom(ids) {
    return new Promise((resolve) => resolve(ids));
}
